import _get from 'hs-lodash/get';
import { useContext, useMemo, useRef } from 'react';
import { PROPERTY_NAME_TO_REFERENCE_TYPE } from '../constants/associations';
import { objectTypes, pluralTypeToSingle } from '../constants/types';
import { PropertiesContext } from '../contexts/properties/context';
const useSelectValues = ({
  property,
  objectType
}) => {
  const {
    externalOptions
  } = useContext(PropertiesContext);
  const hardcodedRefType = useRef(_get(PROPERTY_NAME_TO_REFERENCE_TYPE[pluralTypeToSingle[objectType || objectTypes.contacts]], property.name, ''));
  const referenceType = useMemo(() => property.referenceType || property.referencedObjectType || hardcodedRefType.current || '', [property]);
  const fetchedExternadOptions = useMemo(() => externalOptions[pluralTypeToSingle[objectType]][referenceType], [externalOptions, objectType, referenceType]);
  return {
    fetchedExternadOptions,
    referenceType,
    hardcodedRefType
  };
};
export default useSelectValues;